export const ORDER_PLACEMENT = 'ORDER_PLACEMENT';
export const PLACE_ORDER_REQUEST = `${ORDER_PLACEMENT}/placeOrderRequest`;
export const PAY_ORDER_REQUEST = `${ORDER_PLACEMENT}/payOrderRequest`;
export const PAY_SUCCESS_REQUEST = `${ORDER_PLACEMENT}/paymentSuccessRequest`;
export const PAY_FAILURE_REQUEST = `${ORDER_PLACEMENT}/paymentFailedRequest`;
export const SEND_FEEDBACK_REQUEST = `${ORDER_PLACEMENT}/sendFeedbackRequest`;
export const GET_MENU_DETAIL_REQUEST = `${ORDER_PLACEMENT}/getMenuDetailsRequest`;
export const NOTIFY_MANAGERS_REQUEST = `${ORDER_PLACEMENT}/notifyManagersRequest`;
export const GET_CURRENT_ORDER_REQUEST = `${ORDER_PLACEMENT}/getCurrentOrderRequest`;
